module.exports = __webpack_public_path__ + "static/media/SVG_forward_right_icon.0c9bda4c.svg";